
import { Mixins, Component } from 'vue-property-decorator';
import { IBTNCONF } from '@/types/base.d';
import api from '@/api/course';
import tButton from '@/components/Button/tButton.vue';
import BsMixin from '@/views/Home/mixins/bsMixin';
import tAction from '@/components/Action/action.vue';
import tTable from '@/components/Table/table.vue';
import tableMixin from './tableMixin';
import addQuestionModal from './components/addQuestionModal.vue';
import deleteConfirmModal from './components/deleteConfirmModal.vue';
import { Button } from 'element-ui';

@Component({
  components: {
    addQuestionModal,
    deleteConfirmModal,
    tAction,
    tTable,
    Button,
  },
})
export default class Assignment extends Mixins(BsMixin, tableMixin) {
  public arrs: Array<any> = [];

  private actionBtns: Array<IBTNCONF> = [{
    title: '新增题目',
    name: '/course/chapter/assignment:add',
    icon: 'plus',
    callback: this.handleAddQuestion,
    log: {
      name: '作业 - 新增题目',
      component: 'course/chapter/assignment',
    },
  }];

  public visible = {
    addQuestion: false,
  };

  public row: any = {};

  public title: string = '';

  public $refs!: {
    list: Element,
  }

  mounted() {
    this.initBS(this.$refs.list);
    if (this.chapterId) {
      this.getData(this.chapterId);
    }
  }

  beforeDestroy() {
    Object.keys(this.visible).forEach((key) => {
      this.visible[key] = false;
    });
  }

  handleAddQuestion() {
    this.row.chapterPid = this.chapterId;
    this.title = '添加题目';
    this.visible.addQuestion = true;
  }

  refrsh() {
    this.getData(this.chapterId);
  }
}
